export type Theme = "light" | "dark";

const KEY = "es_theme";

export function getTheme(): Theme {
  return (localStorage.getItem(KEY) as Theme) || "light";
}

export function setTheme(theme: Theme) {
  localStorage.setItem(KEY, theme);
  document.documentElement.setAttribute("data-theme", theme === "dark" ? "dark" : "");
}

// Apply on load
setTheme(getTheme());
